import { startEditProjectDraft } from "$src/application/projects/stores/projectStore";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { EditStatus } from "$src/domain/core/EditStatus";
import { DraftPermission } from "$src/domain/projects/drafts/DraftPermission";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class TakeOverDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<DraftPermission> {

        console.log('do take over', groupStoreId, projectId);

        var permission = await this.projectDraftRepository.TakeOverDraft(groupStoreId, projectId);

        switch(permission.status)
        {
            case EditStatus.Allowed:
                startEditProjectDraft(groupStoreId, permission.projectDraft);
                break;
        }

        return permission;
    }
}

export const TakeOverDraftToken = Symbol('TakeOverDraftToken');